package ru.villawonka.app.presentation.di

import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module
import ru.villawonka.app.domain.model.PostTypeDomain
import ru.villawonka.app.presentation.screens.favorites.viewmodel.FavoritesViewModel
import ru.villawonka.app.presentation.screens.postCard.viewmodel.PostCardViewModel
import ru.villawonka.app.presentation.screens.search.viewmodel.SearchViewModel
import ru.villawonka.app.presentation.screens.searchFilter.viewmodel.SearchFilterViewModel
import ru.villawonka.app.presentation.screens.settings.viewmodel.SettingsViewModel
import ru.villawonka.app.presentation.screens.setup.viewmodel.SetupViewModel
import ru.villawonka.app.presentation.screens.splash.viewmodel.SplashViewModel
import ru.villawonka.app.presentation.sharedviews.postList.viewmodel.PostListViewModel
import ru.villawonka.app.resources.AppResources

val presentationModule = module {
    single { AppResources }

    factoryOf(::SearchViewModel)
    factoryOf(::SearchFilterViewModel)
    factoryOf(::FavoritesViewModel)
    factoryOf(::SetupViewModel)
    factoryOf(::SettingsViewModel)
    factoryOf(::PostListViewModel)

    factory { (startParam: String?) ->
        SplashViewModel(
            startParam = startParam,
            platform = get(),
            getUserSettingsUseCase = get(),
            isNewUserUseCase = get(),
            appResources = get()
        )
    }
    factory { (postId: Int, postType: PostTypeDomain) ->
        PostCardViewModel(
            postId = postId,
            postType = postType,
            platform = get(),
            userSettingsService = get(),
            requestPostByIdUseCase = get(),
            favoritesService = get(),
        )
    }
}